<template>
  <div>
    <div class="md-card md-card-tabs">
      <div class="md-card-content">
        <div class="box_head">
          <div class="lines_box">
            <div class="line_box text_right">
              <span class="line_1" style="width:100%"></span>
            </div>
            <div class="line_box flex">
              <span class="line_3" :style="{width:dueData+'%'}"></span> <span class="line_2" :style="{width:sellDate+'%'}"></span>
            </div>
          </div>
          <div class="point_box">
            <div
              class="point_item"
              :style="{left:item.x+'%',right:item.r+'%'}"
              v-for="item in pointList"
              :key="item.text"
            >
              <span class></span>
              {{item.text}}
            </div>
          </div>
        </div>
        <div class="flex flex_between" v-show="displayChart">
          <BuyerChartUnit class="flex_1" unitIndex="1" :unitInfo="maturityDays" ></BuyerChartUnit>
          <BuyerChartUnit class="flex_1" unitIndex="2" :unitInfo="latePaymentDays" ></BuyerChartUnit>
          <BuyerChartUnit class="flex_1" unitIndex="3" :unitInfo="durationOnBalance" ></BuyerChartUnit>
        </div>
        <emptyChart v-show="!displayChart"></emptyChart>
        <!-- <div class="chart" ref="myEchartPillar" style="height:400px"></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import BuyerChartUnit from "./BuyerChartUnit";
import EmptyChart from "@/views/dashboard/EmptyChart";

import { mapGetters } from "vuex";
export default {
  components: {
    BuyerChartUnit,
    EmptyChart
  },
  data() {
    return {
      pointList: [
        { text: this.$t("dashboard.PaymentChart.buyingDate"), x: 0 },
        { text: this.$t("investor.exchange.table.header.dueDate"), x: 67 },
        { text: this.$t("dashboard.PaymentChart.payment"), x: "", r: 0 }
      ],
      sellDate: 30,
      dueData: 70,
      chartList: [[], [], []],
      durationOnBalance: [],
      maturityDays: [],
      latePaymentDays: [],
      displayChart: true
    };
  },
  mounted() {},
  computed: {
    ...mapGetters({ dashboardInfo: "dashboardInfo" }),
    realList() {
      return this.chartList;
    }
  },
  watch: {
    dashboardInfo() {
      let { statisticData } = this.dashboardInfo;
      if (statisticData) {
        let {
          durationOnBalance,
          latePaymentDays,
          maturityDays,
        } = statisticData;
        this.chartList[0] = maturityDays ;
        this.chartList[1] = latePaymentDays;
        this.chartList[2] =durationOnBalance;
        this.durationOnBalance=durationOnBalance;
        this.latePaymentDays=latePaymentDays;
        this.maturityDays=maturityDays;
        this.displayChart = (durationOnBalance && durationOnBalance.length >0)
                || (latePaymentDays && latePaymentDays.length >0)
                || (maturityDays && maturityDays.length >0)
      } else {
        this.chartList = [[], [], []];
      }
    }
  }
};
</script>
<style lang="scss">
.box_head {
  padding: 10px 0 50px 0;
}
.lines_box {
  padding: 0 30px;
}
.line_box {
  line-height: 5px;
  margin-bottom: 5px;
  span {
    height: 5px;
    &.line_1 {
      background: #F6DA8F;
    }
    &.line_2 {
      background: #FE766C;
    }
    &.line_3 {
      margin-right: 5px;
      background: #A6D1F9;
    }
  }
}
.point_box {
  position: relative;
  .point_item {
    position: absolute;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  span {
    display: inline-block;
    width: 0;
    height: 0;
    border-bottom: 5px solid #333;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
  }
}
</style>